<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="staffEventTypeAudits && staffEventTypeAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="staffEventTypeAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Staff Event Type audits </ng-template>
</ng-template>
